module.exports = __webpack_public_path__ + "b7d379d10910b6933ae6add9f326aff8.jpeg";